import { render, staticRenderFns } from "./pr-migration.vue?vue&type=template&id=98c37056&"
import script from "./pr-migration.vue?vue&type=script&lang=js&"
export * from "./pr-migration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports